(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('ProductLine', ProductLine);

    ProductLine.$inject = ['$resource'];

    function ProductLine ($resource) {
        var resourceUrl =  'api/product-lines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            "selectList": {url: 'api/product-lines/select-list', method: 'GET', isArray: true}
        });
    }
})();
